import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	ownerPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchFilterAriaSearchDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ownerPlaceholder: {
		id: 'directories.filters-v2.main.content.filter.owner-placeholder',
		defaultMessage: 'Owner',
		description:
			'Placeholder to be displayed for an owner picker on filters page in case there is no owner selected',
	},
	searchPlaceholder: {
		id: 'directories.filters-v2.main.content.filter.search-placeholder',
		defaultMessage: 'Search filters',
		description: 'Placeholder to be displayed for a search field on filters directory page',
	},
	searchFilterAriaSearchDescription: {
		id: 'directories.filters-v2.main.content.filter.search-filter-aria-search-description',
		defaultMessage: 'The table will be filtered below as you type into the field',
		description: 'Describes what the access search filter does for screen reader users',
	},
});
export default messages;
